import Vue from 'vue';
import axios from 'axios';
import userApi from './api';

const USER_REQUEST = 'USER_REQUEST',
	USER_SUCCESS = 'USER_SUCCESS',
	USER_ERROR = 'USER_ERROR',
	CREATE_ACCESS_KEY_REQUEST = 'CREATE_ACCESS_KEY_REQUEST',
	CREATE_ACCESS_KEY_SUCCESS = 'CREATE_ACCESS_KEY_SUCCESS',
	CREATE_ACCESS_KEY_ERROR = 'CREATE_ACCESS_KEY_ERROR',
	AUTH_LOGOUT = 'AUTH_LOGOUT';

const initialStatusState = {
	user: {
		info: {},
		update: {},
		password: {},
		email: {},
		delete: {},
		createTfa: {},
		enableTfa: {},
		disableTfa: {},
		confirmEmail: {}
	}
};

function formatErrors(reason) {
	return {
		authPasswordInvalid: reason.invalidCredentials || reason.type === 'UNAUTHORIZED' || reason.type === 'PASSWORD_REQUIRED',
		changePasswordRequired: reason.newPasswordRequired,
		changePasswordInvalid: reason.newPasswordShort,
		changeEmailInvalid: reason.type === 'INVALID_EMAIL',
		changeEmailTaken: reason.type === 'EMAIL_TAKEN',
		confirmEmailTokenUsed: reason.type === 'TOKEN_USED',
		confirmEmailTokenInvalid: reason.type === 'INVALID_TOKEN',
		confirmEmailTokenExpired: reason.type === 'TOKEN_EXPIRED',
		confirmEmailUserInvalid: reason.type === 'INVALID_USER',
		tfaNotEnabled: reason.type === 'MFA_NOT_ENABLED',
		tfaFirstCodeInvalid: reason.type === 'CODE_NOT_VALID' && reason.message.toLowerCase().includes('first'),
		tfaSecondCodeInvalid: reason.type === 'CODE_NOT_VALID' && reason.message.toLowerCase().includes('second'),
		cidrRequired: reason.type === 'CIDR_REQUIRED',
		cidrInvalid: reason.type === 'INVALID_CIDR'
	};
}

function resetStatusState () {
	return initialStatusState.user;
}

const state = {
	status: initialStatusState,
	user: {},
	activeKeys: [],
	tfa: {},
	createAccessKeyStatus: {},
};

const getters = {
	user: state => state.user,
	activeKeys: state => state.activeKeys,
	token: state => state.user.token,
	roles: state => state.user.roles || {},
	isUserLoaded: state => !!state.user.email,
	userStatus: state => state.status.user.info || {},
    createAccessKeyStatus: state => state.createAccessKeyStatus,
	tfa: state => state.tfa
};

function success() {
	return {
		success: true
	};
}

function loading() {
	return {
		loading: true
	};
}

function error(error) {
	return {
		error: error && formatErrors(error) || true
	};
}

const actions = {
	[USER_REQUEST]: ({ commit, dispatch }) => {
		commit(USER_REQUEST);

		return userApi.getUser()
			.then(response => {
				commit(USER_SUCCESS, response);
				dispatch('GET_STATS_REQUEST', { credits: true});
				if (!(response.activeKeys && response.activeKeys.length)) {
					dispatch('CREATE_ACCESS_KEY_REQUEST');
				}
			})
			.catch(error => {
				commit(USER_ERROR);
				// if response is unauthorized, logout
				dispatch(AUTH_LOGOUT);
			});
	},
	[CREATE_ACCESS_KEY_REQUEST]: ({ commit, dispatch, rootGetters }, payload) => {
		if (rootGetters.createAccessKeyStatus.loading || (rootGetters.activeKeys && rootGetters.activeKeys.length)) {
			return;
		}
		commit(CREATE_ACCESS_KEY_REQUEST);
		userApi.createAccessKey()
			.then(response => {
				let newAccessKey = response && response.accessKey;
				commit(CREATE_ACCESS_KEY_SUCCESS, newAccessKey);
			})
			.catch(error => {
				commit(CREATE_ACCESS_KEY_ERROR);
			});
	},
};

const mutations = {
	[USER_REQUEST]: (state) => {
		state.status.user.info = loading();
	},
	[USER_SUCCESS]: (state, response) => {
		state.status.user.info = success();
		if (response.activeKeys && response.activeKeys.length) {
			Vue.set(state, 'activeKeys', Array.from(new Set([...state.activeKeys, ...response.activeKeys])));
		}
		Vue.set(state, 'user', response);
	},
	[USER_ERROR]: (state, response) => {
		state.status.user.info = error(response);
	},
	[AUTH_LOGOUT]: (state) => {
		state.user = {};
	},
	[CREATE_ACCESS_KEY_REQUEST]: (state) => {
		state.createAccessKeyStatus = {
			loading: true
        };
	},
	[CREATE_ACCESS_KEY_SUCCESS]: (state, newAccessKey) => {
		if (newAccessKey) {
			state.activeKeys.push(newAccessKey);
		}
		state.createAccessKeyStatus = {
			success: true
		};
	},
	[CREATE_ACCESS_KEY_ERROR]: (state) => {
		state.createAccessKeyStatus = {
			error: true
		};
    }
};

export default {
	state,
	getters,
	actions,
	mutations,
};



// WEBPACK FOOTER //
// ./src/modules/user/store.js